import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {replace} from 'react-router-redux';
import reduxRouteChanged from 'services/reduxRouteChanged.js';
import Layout from "../../../auth/Layout";
import {FormattedMessage, injectIntl} from "react-intl";
import CSSModules from "react-css-modules";
import styles from "./passwordUpdated.scss";
import loginUrl from "../../../utils/url/loginUrl";


@injectIntl
@connect(
  () => {
    return {
    };
  },
  (dispatch) => {
    return {
      redirect: (path) => dispatch(replace(path)),
    };
  }
)
@CSSModules(styles)
class PasswordUpdated extends React.Component {

  static propTypes = {
    redirect: PropTypes.func,
  };

  redirectToLogin() {
    this.props.redirect(loginUrl());
  }

  render() {

    return (
      <Layout>
        <div styleName="title" data-at="passwordUpdatedSuccessfully">
          <FormattedMessage id="passwordUpdated.title.message"/>
        </div>
        <button styleName={"login"} onClick={() => this.redirectToLogin()}>Log in</button>
      </Layout>
    );

  }
}

function initStore() {
}

export default reduxRouteChanged(initStore, PasswordUpdated);



// WEBPACK FOOTER //
// ./src/containers/auth/passwordUpdated/passwordUpdated.js